import { render, staticRenderFns } from "./aboutUs.vue?vue&type=template&id=518c8ea9&scoped=true"
import script from "./aboutUs.vue?vue&type=script&lang=js"
export * from "./aboutUs.vue?vue&type=script&lang=js"
import style0 from "./aboutUs.vue?vue&type=style&index=0&id=518c8ea9&prod&scoped=true&lang=css"
import style1 from "./aboutUs.vue?vue&type=style&index=1&id=518c8ea9&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "518c8ea9",
  null
  
)

export default component.exports